export * from '@swim/recon';
export * from '@swim/client';
export * from '@swim/ui';
export * from '@swim/ux';
import { UiForm } from '@swim/ui';
if (typeof document !== 'undefined') {
    document.addEventListener('DOMContentLoaded', function (event) {
        UiForm.Global.materializeScripts();
    });
}
import { AppModel } from '@swim/ui';
if (typeof importScripts === 'function') {
    new AppModel();
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxjQUFjLGFBQWEsQ0FBQztBQUU1QixjQUFjLGNBQWMsQ0FBQztBQUU3QixjQUFjLFVBQVUsQ0FBQztBQUV6QixjQUFjLFVBQVUsQ0FBQztBQUV6QixPQUFPLEVBQUMsTUFBTSxFQUFDLE1BQU0sVUFBVSxDQUFDO0FBR2hDLEVBQUUsQ0FBQyxDQUFDLE9BQU8sUUFBUSxLQUFLLFdBQVcsQ0FBQyxDQUFDLENBQUM7SUFDcEMsUUFBUSxDQUFDLGdCQUFnQixDQUFDLGtCQUFrQixFQUFFLFVBQVUsS0FBWTtRQUVsRSxNQUFNLENBQUMsTUFBTSxDQUFDLGtCQUFrQixFQUFFLENBQUM7SUFDckMsQ0FBQyxDQUFDLENBQUM7QUFDTCxDQUFDO0FBR0QsT0FBTyxFQUFDLFFBQVEsRUFBQyxNQUFNLFVBQVUsQ0FBQztBQUNsQyxFQUFFLENBQUMsQ0FBQyxPQUFPLGFBQWEsS0FBSyxVQUFVLENBQUMsQ0FBQyxDQUFDO0lBR3hDLElBQUksUUFBUSxFQUFFLENBQUM7QUFDakIsQ0FBQyJ9